import * as Api from '@ViewModels';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Industry } from '../../../../extViewmodels';
import { CampaignType } from '../../../../models/AdminModels';
import { useEventLogging } from '../../../../models/Logging';
import { useAdminUserSession } from '../../../../models/hooks/adminStateHooks';
import { useErrorMessages, useFullscreenModal } from '../../../../models/hooks/appStateHooks';
import { TemplateCategoriesViewModel } from '../../../../viewmodels/AdminViewModels';
import { CategoriesByIndustry } from '../CategoriesByIndustry';

function _AdminIndustryTemplatesSocialTabContent({ industry }: { industry: Industry }) {
	const userSession = useAdminUserSession();
	const errorMessages = useErrorMessages();
	const fullscreenModal = useFullscreenModal();
	const { logApiError } = useEventLogging('SocialTabContent');
	const [categoriesVm] = React.useState(new TemplateCategoriesViewModel(userSession, industry, CampaignType.Social));
	React.useEffect(() => {
		categoriesVm.load()?.catch((error: Api.IOperationResultNoValue) => {
			logApiError(`LoadCampaignTemplatesSocialError`, error);

			errorMessages.pushApiError(error);
		});
	}, [categoriesVm, errorMessages, logApiError]);

	return (
		<CategoriesByIndustry
			industry={industry}
			categories={categoriesVm}
			campaignType={CampaignType.Social}
			onClickNewButton={() =>
				fullscreenModal.history.push({
					pathname: '/campaign-templates/social/edit',
				})
			}
		/>
	);
}

export const AdminIndustryTemplatesSocialTabContent = observer(_AdminIndustryTemplatesSocialTabContent);
